import { useUI } from "providers/UIProvider"

import { getColumns } from "./columns"
import { getActions } from "./actions"

import Table from "components/UI/organisms/Table"
import AddEditDistrictModal from "components/shared/modals/AddEditDistrictModal/AddEditDistrictModal"
import ConfirmationModal from "components/shared/modals/ConfirmationModal"
import { useDistrictsContext } from "providers/DistrictsProvider/DistrictsProvider"
import useDistricts from "hooks/useDistricts"

const DistrictsTable: React.FC = () => {

  const { modals, T } = useUI()
  const { districts, handlePageChagne, currentPage } = useDistrictsContext()
  const { handleEditDistrict, handleDeleteDistrict } = useDistricts()

  const tableActions = getActions({ T, handleEditClick: handleEditDistrict, handleDeleteClick: handleDeleteDistrict })

  const columns = getColumns(T)

  return (
    <>
      {modals.addEditDistrictModal && (
        <AddEditDistrictModal />
      )}
      <ConfirmationModal
      />
      <Table
        data={districts.data}
        columns={columns}
        actions={tableActions}
        extraHeaderCols={1}
        pagination={{
          total: districts.itemCount,
          perPage: districts.take,
          currentPage,
          onClick: handlePageChagne
        }}
      />
    </>
  )
}

export default DistrictsTable

